import { useRouter } from '@tanstack/react-router';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import Navbar from '@/layouts/navbar/Navbar';
// import { useGlobalSettingsStore } from '@/store/useGlobalSettingsStore';
import { useNewsLetterStore } from '@/store/useNewsLetterStore';

import Footer from './Footer';
import NewsletterSidebar from './NewsletterSidebar';
// import OpenAiChat from './OpenAiChat';
import UnsubscribeBanner from './UnsubscribeBanner';

const PageLayout = ({ children }: { children: React.ReactNode }) => {
  // const globalSettings = useGlobalSettingsStore(
  //   useShallow((state) => state.globalSettings),
  // );
  // const isGlobalAdmin = globalSettings?.role === 'Global Admin';

  const router = useRouter();
  const isHomePage = router.state.location.pathname === '/';
  const isMarketing = isHomePage || router.state.location.pathname.startsWith('/blogs');

  const { open, onClose } = useNewsLetterStore(
    useShallow(state => ({
      open: state.open,
      onClose: state.onClose
    }))
  );

  return (
    <>
      <div className='relative flex grow flex-col overflow-x-hidden'>
        {!isHomePage ? <Navbar /> : null}
        <UnsubscribeBanner />
        <main>{children}</main>
        <NewsletterSidebar open={open} onClose={onClose} />
        {/*{isGlobalAdmin && <OpenAiChat />}*/}
      </div>
      <footer>{!isMarketing && <Footer />}</footer>
    </>
  );
};

export default PageLayout;
